var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "720" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-stati-mercati-card" },
        [
          _c(
            "v-card-title",
            { staticClass: "navy darken-1 white--text" },
            [
              _vm._v("\n      Stato mercati\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { depressed: "", light: "", icon: "" },
                  on: { click: _vm.dismiss },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-4" },
            [
              _vm.isMercatoAstaLiveNonAttivo
                ? _c(
                    "v-alert",
                    {
                      staticClass: "alert-hint mb-4",
                      attrs: { type: "warning", dense: "", outlined: "" },
                    },
                    [
                      _vm._v("\n        Per avviare "),
                      _c("b", [_vm._v("Asta Live")]),
                      _vm._v(
                        " l'" +
                          _vm._s(_vm.adminLegaDivisioneLabel) +
                          " deve prima\n        impostare su "
                      ),
                      _c("b", [_vm._v("ATTIVO")]),
                      _vm._v(" questo tipo di mercato.\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.error
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "error", dense: "", outlined: "" },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-simple-table",
                { staticClass: "mercati-table", attrs: { dense: "" } },
                [
                  _c("tbody", [
                    _vm.loading
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "py-4 text-center",
                              attrs: { colspan: "2" },
                            },
                            [
                              _vm._v(
                                "\n              Caricamento...\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mercatoAstaLive
                      ? _c("tr", [
                          _c("td", { staticClass: "mercato-cell" }, [
                            _c("div", { staticClass: "mercato-title" }, [
                              _vm.mercatoIcon(_vm.mercatoAstaLive)
                                ? _c("img", {
                                    staticClass: "mercato-icon",
                                    attrs: {
                                      src: _vm.mercatoIcon(_vm.mercatoAstaLive),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.mercatoAstaLive.text)),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "mercato-select-cell" },
                            [
                              _c("stato-mercato-select", {
                                key: _vm.statoMercatoSelectKey(
                                  _vm.mercatoAstaLive
                                ),
                                class: {
                                  "asta-live-status-select":
                                    _vm.shouldPulseMercato(_vm.mercatoAstaLive),
                                },
                                attrs: {
                                  value: _vm.mercatoAstaLive.statoMercato,
                                  "tipo-mercato": _vm.mercatoAstaLive,
                                  disabled:
                                    _vm.loading ||
                                    _vm.isSaving(_vm.mercatoAstaLive),
                                  loading: _vm.isSaving(_vm.mercatoAstaLive),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.save(_vm.mercatoAstaLive, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              !_vm.loading && _vm.altriMercati.length > 0
                ? _c(
                    "div",
                    { staticClass: "mercati-section-title navy--text" },
                    [_vm._v("\n        Altri tipi di aste\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading && _vm.altriMercati.length > 0
                ? _c(
                    "v-simple-table",
                    { staticClass: "mercati-table", attrs: { dense: "" } },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.altriMercati, function (mercato) {
                          return _c("tr", { key: mercato.id }, [
                            _c("td", { staticClass: "mercato-cell" }, [
                              _c("div", { staticClass: "mercato-title" }, [
                                _vm.mercatoIcon(mercato)
                                  ? _c("img", {
                                      staticClass: "mercato-icon",
                                      attrs: {
                                        src: _vm.mercatoIcon(mercato),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(mercato.text))]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "mercato-select-cell" },
                              [
                                _c("stato-mercato-select", {
                                  key: _vm.statoMercatoSelectKey(mercato),
                                  attrs: {
                                    value: mercato.statoMercato,
                                    "tipo-mercato": mercato,
                                    disabled:
                                      _vm.loading || _vm.isSaving(mercato),
                                    loading: _vm.isSaving(mercato),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.save(mercato, $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }